module.exports = __webpack_public_path__ + "static/media/couponsprite.489500cd.svg";